/* Aperte — bula de chat WhatsApp. Deschidere/inchidere, Escape, click in afara. */

(function () {
  function init() {
    var root = document.querySelector('.aperte-wa');
    if (!root) return;

    var toggle = root.querySelector('.aperte-wa__toggle');
    var panel = root.querySelector('.aperte-wa__panel');
    var closeBtn = root.querySelector('.aperte-wa__close');
    var cta = root.querySelector('.aperte-wa__cta');
    if (!toggle || !panel) return;

    function isOpen() {
      return root.hasAttribute('open');
    }

    function open() {
      root.setAttribute('open', '');
      toggle.setAttribute('aria-expanded', 'true');
      // Amanam focusul: panoul e inca 'visibility: hidden' pana la recalculul stilului.
      if (cta) setTimeout(function () { cta.focus(); }, 0);
    }

    function close(returnFocus) {
      root.removeAttribute('open');
      toggle.setAttribute('aria-expanded', 'false');
      if (returnFocus) toggle.focus();
    }

    toggle.addEventListener('click', function () {
      if (isOpen()) {
        close(false);
      } else {
        open();
      }
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        close(true);
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && isOpen()) close(true);
    });

    document.addEventListener('click', function (event) {
      if (isOpen() && !root.contains(event.target)) close(false);
    });

    // Bara de consimtamant Shopify e fixata jos, pe toata latimea, cu z-index urias.
    // Cat timp e pe ecran, ridicam bula deasupra ei in loc s-o acoperim.
    function adjustForBanner() {
      var banner = document.getElementById('shopify-pc__banner');
      var offset = 0;

      if (banner) {
        var rect = banner.getBoundingClientRect();
        var onScreen = rect.height > 0 && rect.bottom > window.innerHeight - 5;
        if (onScreen) offset = Math.round(rect.height) + 8;
      }

      root.style.setProperty('--aperte-wa-offset', offset ? offset + 'px' : '');
    }

    // Fara requestAnimationFrame: nu ruleaza cand tabul nu e vizibil si ar bloca
    // reactualizarea. Verificam imediat, apoi inca o data dupa ce bara se retrage.
    var adjustTimer = null;
    function scheduleAdjust() {
      adjustForBanner();
      clearTimeout(adjustTimer);
      adjustTimer = setTimeout(adjustForBanner, 350);
    }

    adjustForBanner();
    window.addEventListener('resize', scheduleAdjust);
    document.addEventListener('click', scheduleAdjust, true);
    new MutationObserver(scheduleAdjust).observe(document.body, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
